import { createBrowserClient } from '@supabase/ssr';
import { createClient as createSupabaseClient } from '@supabase/supabase-js';
import { supabaseFetch } from './gateway-retry';

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    // A read that gets Cloudflare's 502 page is sent once more; see gateway-retry.ts.
    { global: { fetch: supabaseFetch } }
  );
}

// Implicit-flow client used only for password reset emails. PKCE (the
// SSR default) ties the email link to a verifier cookie on the requesting
// browser, so a reset requested on desktop and clicked on mobile fails
// with `error=invalid_link`. @supabase/ssr's createBrowserClient hard-
// codes flowType: 'pkce' and ignores overrides, so we drop down to
// @supabase/supabase-js directly. Implicit-flow tokens come without the
// `pkce_` prefix and verifyOtp in /auth/callback can redeem them on any
// device. No session is persisted from this client — it's only used to
// send the reset email.
export function createResetClient() {
  return createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    { auth: { flowType: 'implicit', persistSession: false } }
  );
}
